import { useLayoutEffect, useRef } from 'react';
import useNavItems from '../../../hooks/useNavItems';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { setIsVerticalNavEnabled } from '../../../reducers/AppConfig';
import useLocation from '../../../hooks/useLocation';
import { updatePageWidthForVerticalNav } from '../utils/updatePageWidthForVerticalNav';
import getIsVerticalNavEnabledForTheCurrentPath from '../../../utils/getIsVerticalNavEnabledForTheCurrentPath';
const useVerticalNavContextualRendering = () => {
  const timeoutRef = useRef(undefined);
  const {
    isVerticalNavEnabled
  } = useAppSelector(state => state.appConfig);
  const shouldShowNav = useAppSelector(state => state.overlayDisplayConfigState.shouldShowNav);
  const {
    primaryNav,
    verticalNavExclusionRoutes
  } = useNavItems();
  const {
    pathname,
    href
  } = useLocation();
  const dispatch = useAppDispatch();
  useLayoutEffect(() => {
    const updateVerticalNavDimensions = () => {
      const shouldVerticalNavBeEnabledForTheCurrentPath = !!primaryNav.navItems.length && getIsVerticalNavEnabledForTheCurrentPath({
        verticalNavExclusionRoutes,
        pathname
      });
      updatePageWidthForVerticalNav({
        isVerticalNavEnabled: shouldVerticalNavBeEnabledForTheCurrentPath
      });
      dispatch(setIsVerticalNavEnabled({
        isVerticalNavEnabled: shouldVerticalNavBeEnabledForTheCurrentPath
      }));
    };

    // delay execution to check for the presence of an editor layout
    timeoutRef.current = setTimeout(updateVerticalNavDimensions, 0);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [dispatch, isVerticalNavEnabled, pathname, primaryNav, verticalNavExclusionRoutes, href]);
  return isVerticalNavEnabled && shouldShowNav;
};
export default useVerticalNavContextualRendering;